// extracted by mini-css-extract-plugin
module.exports = {"IndexPage":"IndexPage_IndexPage__2LWfp"};